import { ProductosApiService } from '../../../../../service/api/productos-api';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../base-form';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { TratamientosApiService } from '../../../../../service/api/tratamientos-api.service';
import { FitosanitariosFormDefinition } from './form-control/form-definition';
import { build, pool, buildParams } from '../../../../../common/classes/request-builder';
import { EventPhase, FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { WeatherService } from '../../../../../service/api/weather/weather';
import { RecuperarReferenciaRecetaService } from '../../../../../service/recuperar.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { UsuariosApiService } from '../../../../../service/api/usuarios-api.service';
import { firstValueFrom } from 'rxjs';
import { TareaFitoModel } from '../../../../../models/tareas/tarea-fito.model';
import { TratamientosControlModel } from '../../../../../models/tratamientos/tratamientos-control.model';
import { MantenimientoModel } from '../../../../../models/trabajadores/mantenimiento.model';
import { DropdownData, ReactiveFormChangedField, ReactiveFormValue, FormType } from '@fitogest/reactive-form-builder/interfaces';
import { FitosanitariosEnvironmentDefinition } from '../environment-variables';
import { environment } from '../../../../../../environments/environment';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { Utils } from '../../../../../common/utils';
import { ClienteModel } from '../../../../../models/cliente.model';
import { ParcelasModel } from '../../../../../models/form-common/parcelas.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { Validators } from '@angular/forms';
import { TratamientosModel } from 'src/app/models/tratamientos/tratamientos.model';

const _createdAgroForFitoIds = new Set<string>();

@Component({
  selector: 'app-formulario-pulverizacion',
  standalone: false,
  templateUrl: './fitosanitarios-form.component.html',
  styleUrls: ['./fitosanitarios-form.component.scss'],
})
export class FitosanitariosFormComponent extends BaseForm<TareaFitoModel> implements OnInit, OnDestroy {
  private static readonly DEBUG_REPEATED_CHANGE_THRESHOLD = 20;

  private static readonly DEBUG_LOG_INTERVAL = 10;

  private static readonly MINUTES_PER_HOUR = 60;

  private static readonly HOURS_PER_DAY = 24;

  private static readonly MAX_TIME_MINUTE = 59;

  private static readonly TIME_PART_PAD_LENGTH = 2;

  disabledDates: Date[] = [];

  form!: FitosanitariosFormDefinition;

  formRequest: ReactiveFormRequestCoordinator<TareaFitoModel>;

  env: FitosanitariosEnvironmentDefinition = new FitosanitariosEnvironmentDefinition();

  rol = StorageManager.getUser().rol;

  public loadingData = true;

  public readonly debugFitosanitariosForm = localStorage.getItem('debugFitosanitariosForm') === '1';

  public formReady = false;

  public previousDataLoaded: TareaFitoModel | null = null;

  private formChangesDebugCount = 0;

  private repeatedChangeDebugCount = 0;

  private lastDebugChangedFieldName = '';

  private lastReloadedClientDropdownId = '';

  private isLoadingInitialDropdowns = false;

  private isReloadingClientDropdowns = false;

  productsTratamientos: any[] = [];

  private _multiselectMergeOverride: Record<string, any[]> = {};


  constructor(
    public override route: ActivatedRoute,
    public override dashboard: DashboardService,
    public formApi: FormCommonApiService,
    public usuariosApi: UsuariosApiService,
    public tareasApi: TareasApiService,
    public fincasApi: FincasApiService,
    public trabajadoresApi: TrabajadoresApiService,
    public tratamientosApi: TratamientosApiService,
    public clientesApi: ClientesApiService,
    public productosApi: ProductosApiService,
    public siexApi: SiexApiService,
    public override router: Router,
    public dashboardEvent: DashboardService,
    private weatherService: WeatherService,
    private recuperarService: RecuperarReferenciaRecetaService,
    private http: HttpClient,
    private messageService: MessageService,
  ) {
    super(
      route,
      router,
      dashboard,
      tareasApi.fitosanitariosPUT,
      tareasApi.fitosanitariosPOST,
      'fitosanitarios',
      'Actualizar Tarea Fitosanitaria',
      'Realizar Tarea Fitosanitaria',
      'Duplicar Tarea Fitosanitaria',
    );
    this.formRequest = new ReactiveFormRequestCoordinator<TareaFitoModel>();
  }

  ngOnInit() {
    this.dashboard.clientChanges$.subscribe(() => {
      this.fincasApi.fincasGET.unsuscribe();
      this.fincasApi.sectoresGET.unsuscribe();
      this.fincasApi.parcelasGET.unsuscribe();
      this.tratamientosApi.tratamientosList.unsuscribe();
      if (this.env.filterAplicadoresByClient) {
        this.trabajadoresApi.trabajadoresGET.unsuscribe();
        this.trabajadoresApi.maquinariaGET.unsuscribe();
      }
    });

    this.expandFormRequest();
    this.softInit(this.getType());
    this.setupFormConFechas();
  }

  override ngOnDestroy(): void {
    this.messageService.clear();

    if (this._checkAppsTimer) {
      clearTimeout(this._checkAppsTimer);
      this._checkAppsTimer = null;
    }
  }

  onAfterSend(serverResponse?: any): void {
    if (this.getType() === FormType.CREATION || this.getType() === FormType.DUPLICATION) {
      const idTareaFito = Array.isArray(serverResponse)
        ? serverResponse[0]?.id ?? null
        : serverResponse?.data?.id ?? serverResponse?.id ?? null;

      if (!idTareaFito) return;

      const cultivoRaw: string = Array.isArray(serverResponse)
        ? serverResponse[0]?.cultivo ?? ''
        : serverResponse?.cultivo ?? '';

      const isArroz = cultivoRaw
        .split(';')
        .some(c => c.trim().toLowerCase() === 'arroz');

      if (!isArroz) return;

      // Evitar doble creación para el mismo id de tarea fito
      if (_createdAgroForFitoIds.has(String(idTareaFito))) return;
      _createdAgroForFitoIds.add(String(idTareaFito));

      this.createTaskAgro(String(idTareaFito));

    } else if (this.getType() === FormType.EDITION) {
      this.updateTaskAgro();
    }
  }

  async createTaskAgro(idTareaFito?: string | null) {
    if (environment.appName !== 'avafitogest') return;
    if (!idTareaFito) return;

    const parcelas = this.form.model.ids_parcelas as ParcelasModel[];
    const idsParcelas = parcelas.map(p => p.id).join(';');
    const idsSectores = (this.form.model.id_sector as SectorModel[])
      .map(s => s.id).join(';');

    const anio = this.getYearFromDDMMYYYY(this.form.model.fecha_fin as string)
      ?? this.getYearFromDDMMYYYY(this.form.model.fecha_inicio as string)
      ?? new Date().getFullYear();

    const fechaFinStr = this.form.model.fecha_fin as string;
    const fechaSecaInicio = moment(Utils.toDate(fechaFinStr)).add(-1, 'days').format('DD/MM/YYYY');
    const fechaSecaFin    = moment(Utils.toDate(fechaFinStr)).add(+1, 'days').format('DD/MM/YYYY');

    const tieneZonaBaja = parcelas.some(p =>
      (p.zona_riego ?? '').toString().toLowerCase().includes('baja')
    );

    let fechaInicioCultivo: string;
    let fechaFinCultivo: string;
    let diaInicioStr = '';
    let diaFinStr    = '';
    let fechaInicioInvernal: string | null = null;
    let fechaFinInvernal: string | null = null;
    let fechasReutilizadas = false;

    try {
      const paramsGetAgro = new HttpParams()
        .append('p1', 'generic')
        .append('p2', 'tareas_agroambientales')
        .append('id_cliente', String(this.form.model.id_cliente ?? ''));

      const agroResp: any = await firstValueFrom(
        this.http.get<any>(`${environment.serverUrl}ws/index.php`, { params: paramsGetAgro })
      );

      const agroLista: any[] = Array.isArray(agroResp)
        ? agroResp
        : (agroResp?.data ?? []);

      const parcelaIdsSet = new Set(idsParcelas.split(';').filter(Boolean));

      const tareaRef = agroLista.find(t => {
        if (!t?.fecha_inicio_inundacion_cultivo || !t?.fecha_fin_inundacion_cultivo) return false;
        const tParcelas = (t.id_parcelas ?? '').toString().split(';').filter(Boolean);
        return tParcelas.some((id: string) => parcelaIdsSet.has(id));
      }) ?? null;

      if (tareaRef) {
        fechaInicioCultivo = tareaRef.fecha_inicio_inundacion_cultivo;
        fechaFinCultivo    = tareaRef.fecha_fin_inundacion_cultivo;
        if (tareaRef.fecha_inicio_inundacion_invernal && tareaRef.fecha_fin_inundacion_invernal) {
          fechaInicioInvernal = tareaRef.fecha_inicio_inundacion_invernal;
          fechaFinInvernal    = tareaRef.fecha_fin_inundacion_invernal;
        }
        fechasReutilizadas = true;
      }
    } catch (e) {
      console.error('Error buscando tareas_agroambientales previas:', e);
    }

    if (fechasReutilizadas) {
      const mInicio = fechaInicioCultivo!.match(/^(\d{2})\//);
      const mFin    = fechaFinCultivo!.match(/^(\d{2})\//);
      const diaInicioExtraido = mInicio ? parseInt(mInicio[1] ?? '0', 10) : 0;
      const diaFinExtraido    = mFin    ? parseInt(mFin[1]    ?? '0', 10) : 0;

      const diaInicio = (diaInicioExtraido >= 11 && diaInicioExtraido <= 14)
        ? diaInicioExtraido
        : this.randomIntBetween(11, 14);
      const diaFin = (diaFinExtraido >= 15 && diaFinExtraido <= 18)
        ? diaFinExtraido
        : this.randomIntBetween(15, 18);

      diaInicioStr = String(diaInicio).padStart(2, '0');
      diaFinStr    = String(diaFin).padStart(2, '0');

      fechaInicioCultivo = `${diaInicioStr}/05/${anio}`;
      fechaFinCultivo    = `${diaFinStr}/08/${anio}`;
    } else {
      const diaInicio = this.randomIntBetween(11, 14);
      const diaFin    = this.randomIntBetween(15, 18);
      diaInicioStr = String(diaInicio).padStart(2, '0');
      diaFinStr    = String(diaFin).padStart(2, '0');
      fechaInicioCultivo = `${diaInicioStr}/05/${anio}`;
      fechaFinCultivo    = `${diaFinStr}/08/${anio}`;
    }

    let fecha_siembra: string | null = null;
    let dosis_siembra: string | null = null;
    let fecha_arroz: string | null = null;
    let fecha_nivelacion: string | null = null;

    try {
      const paramsGet = new HttpParams()
        .append('p1', 'generic')
        .append('p2', 'tareas_ecorregimenes')
        .append('id_cliente', String(this.form.model.id_cliente ?? ''));

      const ecoResp: any = await firstValueFrom(
        this.http.get<any>(`${environment.serverUrl}ws/index.php`, { params: paramsGet })
      );

      const ecoLista: any[] = (Array.isArray(ecoResp)
        ? ecoResp
        : (ecoResp?.data ?? [])
      ).filter((t: any) => String(t?.id_cliente ?? '') === String(this.form.model.id_cliente ?? ''));

      const normalize = (s: any) =>
        (s ?? '').toString()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();

      const ecoNivelacion = ecoLista.find(t =>
        t?.fecha_siembra &&
        t?.dosis_siembra &&
        t?.fecha_recoleccion_arroz &&
        t?.fecha_malashierbas &&
        normalize(t?.tareas_malashierbas).includes('nivelacion')
      ) ?? null;

      const ecoFallback = ecoLista.find(t =>
        t?.fecha_siembra &&
        t?.dosis_siembra &&
        t?.fecha_recoleccion_arroz &&
        t?.fecha_malashierbas
      ) ?? null;

      const ecoRef = ecoNivelacion ?? ecoFallback;

      if (ecoRef) {
        fecha_siembra    = ecoRef.fecha_siembra;
        dosis_siembra    = ecoRef.dosis_siembra;
        fecha_arroz      = ecoRef.fecha_recoleccion_arroz;
        fecha_nivelacion = ecoRef.fecha_malashierbas;
      }
    } catch (e) {
      console.error('Error obteniendo tareas_ecorregimenes:', e);
    }

    const taskAgro: Record<string, any> = {
      id_cliente:                      this.form.model.id_cliente,
      id_usuario:                      StorageManager.getUser().id,
      id_finca:                        (this.form.model.id_finca as any).id,
      id_sector:                       idsSectores,
      id_parcelas:                     idsParcelas,
      fecha_seca_inicio_intermitente:  fechaSecaInicio,
      fecha_seca_fin_intermitente:     fechaSecaFin,
      fecha_inicio_inundacion_cultivo: fechaInicioCultivo!,
      fecha_fin_inundacion_cultivo:    fechaFinCultivo!,
      tipo_ecorregimen:                'Arroz',
      id_tarea_fito:                   idTareaFito,
      fecha_siembra:                   fecha_siembra,
      dosis_siembra:                   dosis_siembra,
      fecha_arroz:                     fecha_arroz,
      fecha_nivelacion:                fecha_nivelacion,
    };

    if (tieneZonaBaja) {
      taskAgro['fecha_inicio_inundacion_invernal'] = fechaInicioInvernal ?? `${diaInicioStr}/11/${anio}`;
      taskAgro['fecha_fin_inundacion_invernal']    = fechaFinInvernal    ?? `${diaFinStr}/01/${anio + 1}`;
    }

    const paramsPost = new HttpParams()
      .append('p1', 'generic')
      .append('p2', 'tareas_agroambientales');

    firstValueFrom(
      this.http.post<any>(`${environment.serverUrl}ws/index.php`, taskAgro, { params: paramsPost })
    ).catch(e => {
      console.error('Error en createTaskAgro:', e);
      _createdAgroForFitoIds.delete(String(idTareaFito));
    });
  }

public formChanges(
    formModel: ReactiveFormValue<TareaFitoModel>,
    lastChangedFieldName: ReactiveFormChangedField<TareaFitoModel>,
  ): void {
    const changedFieldName = String(lastChangedFieldName);

    this.traceFormChange(changedFieldName, formModel);
    this.mergeMultiselectValueIfNeeded(formModel, changedFieldName);

    this.form.model = {
      ...this.form.model,
      ...formModel,
    } as TareaFitoModel;
    this.form.tag = changedFieldName as ReactiveFormChangedField<TareaFitoModel>;

    if (
      changedFieldName === 'id_tratamiento' ||
      changedFieldName === 'ids_parcelas' ||
      changedFieldName === 'fecha_inicio' ||
      changedFieldName === 'fecha_fin'
    ) {
      this.triggerNumeroAplicacionesCheck();
    }

    if (changedFieldName === 'aplicado') {
      this.updateHorasRequired();
    }

    if (changedFieldName === 'hora_inicio' || changedFieldName === 'hora_fin') {
      this.updateHorasTotales();
    }

    if (changedFieldName === 'ids_parcelas' && this.getType() === FormType.CREATION) {
      const selectedParcelas = this.resolveSelectedDropdownEntities<ParcelasModel>(
        this.form.lists.parcelas,
        formModel.ids_parcelas ?? this.form.model.ids_parcelas,
      );

      this.form.model.sup_cultivada = Utils.decimalFormat(
        selectedParcelas.reduce((acc, parcela) => acc + this.toFiniteNumber(parcela.superficie_cultivada), 0),
        2,
        '.',
        ',',
        3,
      );
      this.formBuilderRef.updateForm(this.form.model, false);
    }

    if (this.env.appName === 'pyf') {
      this.form.recuperarService = this.recuperarService;
    }

    if (this.env.showClimatologia) {
      this.form.weatherService = this.weatherService;
    }

    if (this.shouldSkipClientDropdownReload(changedFieldName)) {
      return;
    }

    if (changedFieldName === 'id_cliente' && this.env.appName !== 'agricar') {
      this.reloadClientDropdowns();
    }
  }

  private mergeMultiselectValueIfNeeded(
    formModel: ReactiveFormValue<TareaFitoModel>,
    changedFieldName: string,
  ): void {
    const multiselectFieldNames = ['id_sector', 'ids_parcelas', 'ids_trabajadores', 'id_maquinaria', 'ids_asignados'];

    if (!multiselectFieldNames.includes(changedFieldName)) {
      return;
    }

    const previousValue = Array.isArray(this._multiselectMergeOverride[changedFieldName])
      ? this._multiselectMergeOverride[changedFieldName]
      : Array.isArray((this.form.model as Record<string, unknown>)[changedFieldName])
        ? (this.form.model as Record<string, unknown>)[changedFieldName] as unknown[]
        : [];
    const incomingValue = Array.isArray(formModel[changedFieldName])
      ? formModel[changedFieldName] as unknown[]
      : [];
    const sanitizedPreviousValue = this.sanitizeMultiselectValues(previousValue);
    const sanitizedIncomingValue = this.sanitizeMultiselectValues(incomingValue);
    const control = this.formBuilderRef.model?.get(changedFieldName);

    if (sanitizedIncomingValue.length !== incomingValue.length) {
      formModel[changedFieldName] = sanitizedIncomingValue as never;
      control?.setValue(sanitizedIncomingValue, { emitEvent: false });
    }

    if (sanitizedPreviousValue.length === 0 || sanitizedIncomingValue.length === 0) {
      delete this._multiselectMergeOverride[changedFieldName];
      return;
    }

    const dropdownValues = this.getDropdownValuesForMultiselect(changedFieldName);
    const enrichedPreviousValue = sanitizedPreviousValue
      .map(value => this.enrichDropdownValue(value, dropdownValues))
      .filter(value => this.isMeaningfulDropdownValue(value));
    const previousIds = new Set(enrichedPreviousValue.map(value => this.getDropdownValueId(value)));
    const incomingIds = new Set(sanitizedIncomingValue.map(value => this.getDropdownValueId(value)));
    const addedValues = sanitizedIncomingValue.filter(value => !previousIds.has(this.getDropdownValueId(value)));
    const removedValues = enrichedPreviousValue.filter(value => !incomingIds.has(this.getDropdownValueId(value)));

    if (addedValues.length === 0 || removedValues.length === 0) {
      delete this._multiselectMergeOverride[changedFieldName];
      return;
    }

    const mergedValue = [...sanitizedIncomingValue, ...removedValues];

    formModel[changedFieldName] = mergedValue as never;
    this._multiselectMergeOverride[changedFieldName] = mergedValue;

    if (!control) {
      return;
    }

    control.setValue(mergedValue, { emitEvent: false });
    control.markAsDirty();

    setTimeout(() => control.setValue(mergedValue, { emitEvent: false }), 0);
  }

  private sanitizeMultiselectValues(values: unknown[]): unknown[] {
    return values.filter(value => this.isMeaningfulDropdownValue(value));
  }

  private isMeaningfulDropdownValue(value: unknown): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'string') {
      const normalizedValue = value.trim().toLowerCase();

      return normalizedValue.length > 0 && normalizedValue !== 'null' && normalizedValue !== 'undefined' && normalizedValue !== '...';
    }

    if (typeof value === 'object' && 'id' in value) {
      const id = (value as { id?: unknown }).id;

      return id !== null && id !== undefined && String(id).trim().length > 0;
    }

    return true;
  }

  private getDropdownValuesForMultiselect(changedFieldName: string): unknown[] {
    const listName = changedFieldName === 'id_sector' ? 'sectores'
      : changedFieldName === 'ids_parcelas' ? 'parcelas'
        : changedFieldName === 'ids_trabajadores' ? 'trabajadores'
          : changedFieldName === 'id_maquinaria' ? 'maquinarias'
            : changedFieldName === 'ids_asignados' ? 'usuarios'
              : '';

    if (!listName) {
      return [];
    }

    const list = (this.form.lists as any)[listName];

    return list?.filtered ?? [];
  }

  private enrichDropdownValue(value: unknown, dropdownValues: unknown[]): unknown {
    if (typeof value === 'object' && value !== null) {
      return value;
    }

    const found = dropdownValues.find(option => {
      if (typeof option !== 'object' || option === null || !('value' in option)) {
        return false;
      }

      const optionValue = (option as { value?: unknown }).value;

      if (typeof optionValue === 'object' && optionValue !== null && 'id' in optionValue) {
        return String((optionValue as { id?: unknown }).id ?? '') === String(value);
      }

      return String(optionValue ?? '') === String(value);
    });

    return typeof found === 'object' && found !== null && 'value' in found
      ? (found as { value?: unknown }).value ?? value
      : value;
  }

  private getDropdownValueId(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (typeof value === 'object' && 'id' in value) {
      return String((value as { id?: unknown }).id ?? '');
    }

    return String(value);
  }

  private reloadClientDropdowns(): void {
    const selectedClientId = this.getReactiveValueId(this.form.model.id_cliente as unknown);

    if (!selectedClientId) {
      this.debugFito('Client dropdown reload cancelled: empty client id.');
      return;
    }

    this.isReloadingClientDropdowns = true;
    this.lastReloadedClientDropdownId = selectedClientId;

    const selectedClient = this.resolveSelectedDropdownEntity<ClienteModel>(this.form.lists.clientes, selectedClientId);

    if (selectedClient) {
      StorageManager.saveClient(selectedClient);
    }

    this.dashboardEvent.emitClientChange();

    this.refreshDeclarativeLocationDropdowns();

    const builds = [
      buildParams(this.tratamientosApi.tratamientosList, { id_cliente: selectedClientId }, this.form.lists.tratamientos, 'nombre', true),
    ];

    if (this.env.filterAplicadoresByClient) {
      builds.push(
        buildParams(this.trabajadoresApi.trabajadoresGET, { id_cliente: selectedClientId }, this.form.lists.trabajadores, 'nombre', true),
        buildParams(this.trabajadoresApi.maquinariaGET, { id_cliente: selectedClientId }, this.form.lists.maquinarias, 'nombre', true),
      );
    }

    this.debugFito('Reloading client dropdowns.', { selectedClientId, builds: builds.length });
    this.resetExternalDropdowns();
    this.dropdownLoadTrigger.next();

    pool(builds, () => {
      this.form.lists.tratamientos.filtered = this.form.lists.tratamientos.values;

      if (this.env.filterAplicadoresByClient) {
        this.form.lists.trabajadores.filtered = this.form.lists.trabajadores.values.filter(it => it.label !== '...');
        this.form.lists.maquinarias.filtered = this.form.lists.maquinarias.values;
      }

      this.dropdownLoadTrigger.next();
    }).then(() => {
      this.debugFito('Client dropdown reload finished.', { selectedClientId });
      this.finalizeExternalDropdowns();
      this.isReloadingClientDropdowns = false;
      this.dropdownLoadTrigger.next();
    }).catch((error: unknown) => {
      this.debugFito('Client dropdown reload failed.', error);
      this.finalizeExternalDropdowns();
      this.isReloadingClientDropdowns = false;
      this.dropdownLoadTrigger.next();
      console.error('Error reloading fitosanitarios client dropdowns.', error);
    });
  }


  private refreshDeclarativeLocationDropdowns(): void {
    this.formBuilderRef?.refreshDeclarativeDropdown('id_finca');
    this.formBuilderRef?.refreshDeclarativeDropdown('id_sector');
    this.formBuilderRef?.refreshDeclarativeDropdown('ids_parcelas');
  }

  /** Carga las fechas y luego crea el form-definition con ellas */
  private async setupFormConFechas(): Promise<void> {
    if (environment.appName === 'detorres') {
      const { dates, eventos } = await this.getEventosAPI();

      this.disabledDates = dates;

      this.form = new FitosanitariosFormDefinition(
        this.getType(),
        localStorage.getItem('tratamiento_temp')
          ? JSON.parse(localStorage.getItem('tratamiento_temp')!)
          : this.getModel(),
        null,
        this.disabledDates,
        eventos,
      );
    } else {
      this.form = new FitosanitariosFormDefinition(
        this.getType(),
        localStorage.getItem('tratamiento_temp')
          ? JSON.parse(localStorage.getItem('tratamiento_temp')!)
          : this.getModel(),
        null,
        [],
        [],
      );
    }

    this.configureDeclarativeLocationDataSources();
    this.form.model = this.model;

    const modelId = this.getModel()?.id;

    const [_dropdowns, tareaData] = await Promise.all([
      this.initFormData(),
      modelId
        ? this.tareasApi.fitosanitariosGET.toPromise({ id: String(modelId) } as never)
            .then((res: any) => {
              const arr = Array.isArray(res) ? res : (res?.data ?? [res]);
              return (arr[0] ?? null) as TareaFitoModel | null;
            })
            .catch(() => null)
        : Promise.resolve(null),
    ]);

    if (tareaData) {
      this.previousDataLoaded = this.normalizeLoadedPreviousData(tareaData);
      this.form.model = {
        ...this.form.model,
        ...this.previousDataLoaded,
      } as ReactiveFormValue<TareaFitoModel>;
    }

    this.formReady = true;
    this.formRequest.executePhase(FormPhase.LOAD);
}


  private normalizeLoadedPreviousData(previousData: TareaFitoModel): TareaFitoModel {
    const transformedPreviousData = this.form.formFields.previousDataTransform
      ? this.form.formFields.previousDataTransform(previousData)
      : previousData;
    const horasTotales = this.calculateHorasTotalesFromValues(
      transformedPreviousData.hora_inicio,
      transformedPreviousData.hora_fin,
    );

    if (horasTotales.length === 0) {
      return transformedPreviousData;
    }

    return {
      ...transformedPreviousData,
      horas_totales: horasTotales,
    } as TareaFitoModel;
  }

  private configureDeclarativeLocationDataSources(): void {
    this.form.setLocationDataSources({
      fincas: this.fincasApi.fincasGET,
      sectores: this.fincasApi.sectoresGET,
      parcelas: this.fincasApi.parcelasGET,
    });
  }

  private async updateTaskAgro(): Promise<void> {
    if (environment.appName !== 'avafitogest') return;

    const idTareaFito = this.form.model.id;
    if (!idTareaFito) return;

    const fechaFinStr = this.form.model.fecha_fin as string;
    if (!fechaFinStr) return;

    const parcelas = this.form.model.ids_parcelas as ParcelasModel[];

    try {
      const res: any = await this.tareasApi.agroambientales.GET.toPromise({
        id_tarea_fito: String(idTareaFito),
      } as never);

      const lista: any[] = Array.isArray(res) ? res : (res?.data ?? []);
      const tareaAgro = lista[0] ?? null;
      if (!tareaAgro?.id) return;

      const idsParcelas = parcelas.map(p => p.id).join(';');
      const idsSectores = Array.isArray(this.form.model.id_sector)
        ? (this.form.model.id_sector as SectorModel[]).map(s => s.id).join(';')
        : this.form.model.id_sector;

      const fechaSecaInicio = moment(Utils.toDate(fechaFinStr)).add(-1, 'days').format('DD/MM/YYYY');
      const fechaSecaFin    = moment(Utils.toDate(fechaFinStr)).add(+1, 'days').format('DD/MM/YYYY');

      const body: Record<string, any> = {
        id:                             tareaAgro.id,
        id_finca:                       (this.form.model.id_finca as any)?.id ?? this.form.model.id_finca,
        id_sector:                      idsSectores,
        id_parcelas:                    idsParcelas,
        fecha_seca_inicio_intermitente: fechaSecaInicio,
        fecha_seca_fin_intermitente:    fechaSecaFin,
      };

      const params = new HttpParams()
        .append('p1', 'generic')
        .append('p2', 'tareas_agroambientales')
        .append('p3', String(tareaAgro.id));

      await firstValueFrom(
        this.http.put<any>(`${environment.serverUrl}ws/index.php`, body, { params })
      );

    } catch (e) {
      console.error('Error en updateTaskAgro:', e);
    }
  }

  private expandFormRequest(): void {

    this.formRequest.addEvent(FormPhase.SEND, EventPhase.AFTER, (resolve) => {
      StorageManager.saveSessionDataDonJardin(
        this.form.model.id_finca ?? '',
        this.form.model.hora_inicio ?? '',
        this.form.model.hora_fin?.toString() ?? '',
      );
      resolve(true);
    });

    let isControl = false;
    let controlObtenido: TratamientosControlModel[] = [];

    this.formRequest.addEvent(FormPhase.SEND, EventPhase.AFTER, (resolve) => {
      if (this.env.appName === 'hernandorena') {
        this.tratamientosApi.tratamientosControl.GET.toPromise({
          id_tarea: this.form.model.id,
        } as never).then(control => {
          if (control?.[0]) {
            controlObtenido = control;
            isControl = true;
          } else {
            resolve(true);
          }

          return;
        }).catch(e => {
          console.log(`catch en formRequest: ${e}`);
        },
        );
      } else {
        resolve(true);
      }
    });

    if (isControl) {
      this.tratamientosApi.tratamientosControl.PUT.toPromise({
        id: controlObtenido[0]?.id,
        estado: this.form.model.aplicado ? 'Aplicado' : 'Planificado',
      } as never).then(() => {
        console.log('Control Obtenido');

        return;
      }).catch(e => {
        console.log(`catch en getPosition: ${e}`);
      },
      );
    }

    this.formRequest.addEvent(FormPhase.LOAD, EventPhase.AFTER, (resolve) => {
      this.formReady = true;
      resolve(true);
    });
  }

private initFormData(): Promise<boolean> {
    this.loadingData = true;
    this.isLoadingInitialDropdowns = true;
    this.resetExternalDropdowns();

    const buildsRequest = this.getBuildsRequest();

    this.debugFito('Initial dropdown load started.', { builds: buildsRequest.length });

    return pool(buildsRequest, () => {
      this.dropdownLoadTrigger.next();
    }).then(() => {
      this.loadingData = false;
      this.isLoadingInitialDropdowns = false;
      this.finalizeExternalDropdowns();

      this.debugFito('Initial dropdown load finished.');
      this.dropdownLoadTrigger.next();
      this.triggerNumeroAplicacionesCheck();

      return true;
    }).catch((error: unknown) => {
      this.loadingData = false;
      this.isLoadingInitialDropdowns = false;
      this.finalizeExternalDropdowns();

      this.debugFito('Initial dropdown load failed.', error);
      this.dropdownLoadTrigger.next();
      console.error('Error loading fitosanitarios form data.', error);

      return true;
    });
  }


  private getBuildsRequest(): any {
    const selectedClientId = this.getReactiveValueId(this.form.model.id_cliente as unknown)
      || String(StorageManager.getClient()?.id ?? '');
    const buildsRequest = [
      build(this.clientesApi.clientesGET, this.form.lists.clientes, { or: ['razon_social', 'nombre'] }),
      selectedClientId
        ? buildParams(this.tratamientosApi.tratamientosList, { id_cliente: selectedClientId }, this.form.lists.tratamientos, 'nombre', true)
        : build(this.tratamientosApi.tratamientosList, this.form.lists.tratamientos, 'nombre', true),
      build(this.siexApi.justificacionesActuacionGET, this.form.lists.justificaciones, 'justificacion'),
      this.env.filterAplicadoresByClient && selectedClientId
        ? buildParams(this.trabajadoresApi.maquinariaGET, { id_cliente: selectedClientId }, this.form.lists.maquinarias, 'nombre', true)
        : build(this.trabajadoresApi.maquinariaGET, this.form.lists.maquinarias,
          (it: MaquinariaModel) => `${it.nombre} ${it.empresa
            ? ` - (${it.empresa || '...'})`
            : ''}`, true),
      this.env.filterAplicadoresByClient && selectedClientId
        ? buildParams(this.trabajadoresApi.trabajadoresGET, { id_cliente: selectedClientId }, this.form.lists.trabajadores, 'nombre', true)
        : build(this.trabajadoresApi.trabajadoresGET, this.form.lists.trabajadores,
          (it: MantenimientoModel) => `${it.nombre} ${it.apellidos || ''}${it.maquinaria
            ? ` - (${it.maquinaria || '...'})`
            : ''}`,
          true, true),

    ];

    if (this.env.showAssignUserTasksFitosanitario || this.env.showAssignUserInAllTasks) {
      buildsRequest.push(build(this.usuariosApi.usuariosGET, this.form.lists.usuarios, 'nombre'));
    }

    if (this.env.appName === 'innovia') {
      buildsRequest.push(build(this.productosApi.productos.GET, this.form.lists.productos, 'nombre'));
    }

    return buildsRequest;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public async getEventosAPI(): Promise<{
    dates: Date[];
    eventos: { start: string; title: string; hora_inicio: string; hora_fin: string }[];
  }> {
    const fechas: Date[] = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let eventosRaw: any[] = [];

    try {
      eventosRaw = await this.tareasApi.eventos.GET.toPromise();
      for (const ev of eventosRaw) {
        const [dd, mm, yyyy] = ev.start.split('-').map(Number);

        if ([dd, mm, yyyy].every(Number.isInteger)) {
          fechas.push(new Date(yyyy, mm - 1, dd));
        }
      }
    } catch (err) {
      console.error('Error cargando eventos:', err);
    }

    return { dates: fechas, eventos: eventosRaw };
  }

  async getDataProducts(): Promise<void> {
    const tratamiento = this.resolveCurrentTratamiento();

    if (!tratamiento) {
      this.productsTratamientos = [];
      return;
    }

    if (tratamiento?.ids_usos) {
      const idsUsos = tratamiento.ids_usos.split(';').filter((x: string) => x?.trim()?.length);

      if (idsUsos.length > 0) {
        const result = await firstValueFrom(this.http.get<any>(
          `${environment.serverUrl}ws/index.php?p1=mg&p2=getById&id=${idsUsos}`,
        ));

        this.productsTratamientos = result?.data || [];
      } else {
        this.productsTratamientos = [];
      }
    } else {
      this.productsTratamientos = [];
      this.form.lists.productos.values = [];
      this.form.lists.productos.filtered = [];
    }
  }

  /**
   * Filtra vista por (año fecha aplicacion) + tratamiento + parcela de la tarea actual,
   * cuenta por num_registro_producto y compara con n_aplicaciones del mg/getById.
   */
  private checkNumeroAplicacionesConVista(vistaRows: any[]): void {
    const taskFecha = this.form?.model?.fecha_inicio ?? this.form?.model?.fecha_fin ?? null;
    const taskYear = this.getYearFromDDMMYYYY(taskFecha);

    const parcelaIds = this.getParcelaIdsFromModel(this.form?.model?.ids_parcelas);

    const isDuplicateOrCreate = this.getType() === FormType.CREATION || this.getType() === FormType.DUPLICATION;
    const tareaActualId = (!isDuplicateOrCreate && this.form?.model?.id != null)
      ? String(this.form.model.id)
      : null;

    if (!taskYear || parcelaIds.length === 0) return;

    // 1) Filtrar vista por AÑO + PARCELA, excluyendo tarea actual solo en modo edición
    const filtered = (vistaRows || []).filter(r => {
      const rIdTarea = r?.id_tarea != null ? String(r.id_tarea) : null;
      if (tareaActualId && rIdTarea === tareaActualId) return false;

      const y = this.getYearFromDDMMYYYY(r?.fecha_aplicacion);
      const idPar = String(r?.id_parcela ?? '');

      return (y === taskYear && parcelaIds.includes(idPar));
    });

    // 2) Contar en BD por (registro, parcela) => key = `${registro}__${parcela}`
    const countByRegistroParcela = new Map<string, number>();
    for (const r of filtered) {
      const reg = (r?.num_registro_producto ?? '').toString().trim();
      const idPar = String(r?.id_parcela ?? '').trim();
      if (!reg || !idPar) continue;

      const key = `${reg}__${idPar}`;
      countByRegistroParcela.set(key, (countByRegistroParcela.get(key) || 0) + 1);
    }

    const exceedLines: string[] = [];
    const okLines: string[] = [];

    // 3) Por cada producto del tratamiento actual, calculamos por cada parcela seleccionada
    for (const prod of (this.productsTratamientos || [])) {
      const registro = (prod?.referencia ?? '').toString().trim(); // ej: ES-00003
      if (!registro) continue;

      const maxApps = this.toStrictInt(prod?.n_aplicaciones); // SOLO números
      if (maxApps === null) continue;

      const nombre = prod?.nombre_comercial ?? 'Producto';

      for (const parcelaId of parcelaIds) {
        const key = `${registro}__${parcelaId}`;
        const hechasBD = countByRegistroParcela.get(key) || 0;

        const totalAntesGuardar = hechasBD + 1;

        const label = `${totalAntesGuardar}/${maxApps}`;

        const parcelaTxt = this.getParcelaDisplay(parcelaId);
        const line = `${nombre} (${registro}) · ${parcelaTxt} -> ${label}`;

        if (maxApps > 0 && totalAntesGuardar > maxApps) {
          exceedLines.push(`⚠️ ${line}`);
        } else {
          okLines.push(line);
        }
      }
    }

    // 4) Toast agrupado por severidad (max 3 mensajes: success / warn / error)
    const groups: Record<'success' | 'warn' | 'error', string[]> = {
      success: [],
      warn: [],
      error: [],
    };

    const bullet = (s: string) => `• ${String(s ?? '')}`;

    for (const line of okLines) {
      const safeLine = String(line ?? '');
      const m = safeLine.match(/->\s*(\d+)\s*\/\s*(\d+)\s*$/);

      const hechasStr = m?.[1];
      const maxStr = m?.[2];

      const hechas = typeof hechasStr === 'string' ? parseInt(hechasStr, 10) : null;
      const max = typeof maxStr === 'string' ? parseInt(maxStr, 10) : null;

      let severity: 'success' | 'warn' | 'error' = 'success';
      if (hechas !== null && max !== null) {
        if (hechas < max) severity = 'success';
        else if (hechas === max) severity = 'warn';
        else severity = 'error';
      }

      groups[severity].push(bullet(line));
    }

    for (const line of exceedLines) {
      groups.error.push(bullet(line.replace(/^⚠️\s*/, '')));
    }

    const messages: any[] = [];

    if (groups.error.length) {
      messages.push({
        severity: 'error',
        summary: `Nº aplicaciones superado (${groups.error.length})`,
        detail: groups.error.join('\n'),
        sticky: true,
      });
    }

    if (groups.warn.length) {
      messages.push({
        severity: 'warn',
        summary: `Nº aplicaciones al límite (${groups.warn.length})`,
        detail: groups.warn.join('\n'),
        life: 5000,
      });
    }

    if (groups.success.length) {
      messages.push({
        severity: 'success',
        summary: `Nº aplicaciones OK (${groups.success.length})`,
        detail: groups.success.join('\n'),
        life: 3000,
      });
    }

    this.messageService.clear();
    if (messages.length) {
      this.messageService.addAll(messages);
    }
  }

  /** Devuelve año (YYYY) desde "DD/MM/YYYY" o Date o string. */
  private getYearFromDDMMYYYY(value: any): number | null {
    if (!value) return null;

    // Date object
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value.getFullYear();
    }

    const s = value.toString().trim();

    // "DD/MM/YYYY"
    const m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (m) return parseInt(m[3], 10);

    // "YYYY-MM-DD ..." etc
    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return parseInt(iso[1], 10);

    // fallback moment (por si llega otro formato)
    const mm = moment(s, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
    if (mm.isValid()) return mm.year();

    return null;
  }

  /** Convierte "solo numeros" a int. Si trae texto, devuelve null. */
  private toStrictInt(v: any): number | null {
    if (v === null || v === undefined) return null;
    const s = v.toString().trim();
    if (!/^\d+$/.test(s)) return null;
    return parseInt(s, 10);
  }

  /** Extrae ids de parcelas desde el modelo (array de objetos o ids) */
  private getParcelaIdsFromModel(ids_parcelas: any): string[] {
    if (!ids_parcelas) return [];
    if (Array.isArray(ids_parcelas)) {
      return ids_parcelas
        .map(p => (typeof p === 'object' ? p?.id : p))
        .filter(Boolean)
        .map((x: any) => String(x));
    }
    // si viene como "1;2;3"
    if (typeof ids_parcelas === 'string') {
      return ids_parcelas.split(';').map(x => x.trim()).filter(Boolean);
    }
    return [];
  }

  /** Devuelve el label EXACTO del desplegable para una parcela id (fallbacks incluidos). */
  private getParcelaDropdownLabelById(parcelaId: string): string {
    const id = String(parcelaId ?? '').trim();
    if (!id) return '';

    // 1) Label del dropdown (es el que se muestra en UI)
    const fromDropdown = (this.form?.lists?.parcelas?.values ?? [])
      .find((it: any) => String(it?.value?.id ?? it?.id ?? '') === id);

    if (fromDropdown?.label) return String(fromDropdown.label);

    // 2) Si está en el modelo seleccionado como objeto ParcelasModel
    const selected = this.form?.model?.ids_parcelas;
    if (Array.isArray(selected)) {
      const found = selected.find((p: any) => String(p?.id ?? p) === id);
      if (found && typeof found === 'object') {
        const parcelaLabel = this.parcelaLabel(found as ParcelasModel);

        if (parcelaLabel) return parcelaLabel;

        const nombre = (found?.nombre ?? '').toString().trim();
        if (nombre) return nombre;
      }
    }

    // 3) fallback
    return `Parcela ${id}`;
  }

  /** Devuelve un texto corto de parcela (mismo label del dropdown, pero sin ser kilométrico si quieres). */
  private getParcelaDisplay(parcelaId: string): string {
    // Si quieres el label completo tal cual, devuelve directamente getParcelaDropdownLabelById(parcelaId)
    return this.getParcelaDropdownLabelById(parcelaId);
  }

  private _checkAppsTimer: any = null;

  private triggerNumeroAplicacionesCheck(): void {
    if (this.loadingData) return;

    const fechaReceta = this.form?.model?.fecha_inicio ?? null;
    const tratamientoSel = this.resolveCurrentTratamiento();
    const parcelas = this.form?.model?.ids_parcelas ?? null;

    const hasFecha = !!this.getYearFromDDMMYYYY(fechaReceta);
    const hasTratamiento = !!tratamientoSel;
    const parcelaIds = this.getParcelaIdsFromModel(parcelas);
    const hasParcelas = parcelaIds.length > 0;

    if (!hasFecha || !hasTratamiento || !hasParcelas) return;

    if (this._checkAppsTimer) clearTimeout(this._checkAppsTimer);

    this._checkAppsTimer = setTimeout(async () => {
      try {
        // 1) Cargar productos del tratamiento (mg/getById) SIN usar getDataProducts
        const idsUsosRaw = (tratamientoSel?.ids_usos ?? '').toString().trim();
        if (!idsUsosRaw) {
          this.productsTratamientos = [];
          return;
        }

        const idsUsos = idsUsosRaw.split(';').filter((x: string) => x?.trim()?.length);
        if (idsUsos.length === 0) {
          this.productsTratamientos = [];
          return;
        }

        const mgResp = await firstValueFrom(this.http.get<any>(
          `${environment.serverUrl}ws/index.php?p1=mg&p2=getById&id=${idsUsos}`,
        ));
        this.productsTratamientos = mgResp?.data || [];

        // 2) Leer vista y lanzar comprobación
        const resp: any = await this.productosApi.vistaNumeroAplicaciones.GET.toPromise({} as never);
        const vistaRows: any[] = Array.isArray(resp) ? resp : (resp?.data ?? []);

        this.checkNumeroAplicacionesConVista(vistaRows);
      } catch (e) {
        console.error('Error en triggerNumeroAplicacionesCheck:', e);
      }
    }, 200);
  }

  private parcelaLabel = (p: ParcelasModel) => {
    const nombre = (p.nombre ?? '').toString().trim();
    const variedad = (p.variedad ?? 'SIN VARIEDAD').toString().trim();

    const pol = (p.poligono ?? '').toString().trim();
    const num = (p.numero ?? '').toString().trim();
    const rec = (p.recinto ?? '').toString().trim();
    const codigos = [pol, num, rec].filter(Boolean).join('-');

    const supRaw = (p.superficie_cultivada ?? p.superficie_sigpac ?? p.superficie ?? '0').toString();
    const supNum = parseFloat(supRaw.replace(',', '.')) || 0;
    const supFmt = supNum.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const uds = this.env.textoSuperficie || 'ha';

    let zonaRiegoAbrev = '';
    if ((p.cultivo ?? '').toLowerCase() === 'arroz') {
      const zr = (p.zona_riego ?? '').toString().toLowerCase();
      if (zr.includes('alta')) zonaRiegoAbrev = 'ZA';
      else if (zr.includes('baja')) zonaRiegoAbrev = 'ZB';
    }

    const variedadConZona = zonaRiegoAbrev
      ? `${variedad} - ${zonaRiegoAbrev}`
      : variedad;

    const derecha = [
      codigos || undefined,
      `${supFmt} ${uds}`
    ].filter(Boolean).join(' · ');

    return `${nombre} - ${variedadConZona} — ${derecha}`;
  };

  /** Coerce a value to a finite number; returns 0 if not numeric. */
  public toFiniteNumber(v: unknown): number {
    if (typeof v === 'number') { return Number.isFinite(v) ? v : 0; }
    if (typeof v === 'string') {
      const s = v.trim();

      if (s === '' || /^(?:NaN|undefined|null)$/i.test(s)) { return 0; }
      // remove thousand separators and normalize decimal comma
      const cleaned = s.replace(/\s/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(/,/, '.');
      const n = Number(cleaned);

      return Number.isFinite(n) ? n : 0;
    }
    return 0;
  }

  private randomIntBetween(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  private updateHorasTotales(): void {
    const horasTotales = this.calculateHorasTotalesFromValues(
      this.form.model.hora_inicio,
      this.form.model.hora_fin,
    );

    if (horasTotales.length === 0 || this.form.model.horas_totales === horasTotales) {
      return;
    }

    this.form.model.horas_totales = horasTotales;
    this.formBuilderRef.updateForm({ horas_totales: horasTotales }, false);
  }

  private calculateHorasTotalesFromValues(horaInicio: unknown, horaFin: unknown): string {
    const startMinutes = this.parseTimeToMinutes(horaInicio);
    const endMinutes = this.parseTimeToMinutes(horaFin);

    if (startMinutes === null || endMinutes === null) {
      return '';
    }

    const minutesPerDay = FitosanitariosFormComponent.HOURS_PER_DAY * FitosanitariosFormComponent.MINUTES_PER_HOUR;
    const totalMinutes = endMinutes >= startMinutes
      ? endMinutes - startMinutes
      : (endMinutes + minutesPerDay) - startMinutes;

    return this.formatMinutesAsTime(totalMinutes);
  }

  private parseTimeToMinutes(value: unknown): number | null {
    const timeValue = value instanceof Date
      ? `${value.getHours()}:${value.getMinutes()}`
      : String(value ?? '').trim();
    const match = /^(\d{1,2}):(\d{2})$/.exec(timeValue);

    if (!match) {
      return null;
    }

    const hours = Number(match[1]);
    const minutes = Number(match[2]);

    if (
      !Number.isInteger(hours) ||
      !Number.isInteger(minutes) ||
      hours < 0 ||
      hours >= FitosanitariosFormComponent.HOURS_PER_DAY ||
      minutes < 0 ||
      minutes > FitosanitariosFormComponent.MAX_TIME_MINUTE
    ) {
      return null;
    }

    return (hours * FitosanitariosFormComponent.MINUTES_PER_HOUR) + minutes;
  }

  private formatMinutesAsTime(totalMinutes: number): string {
    const minutesPerDay = FitosanitariosFormComponent.HOURS_PER_DAY * FitosanitariosFormComponent.MINUTES_PER_HOUR;
    const normalizedMinutes = ((totalMinutes % minutesPerDay) + minutesPerDay) % minutesPerDay;
    const hours = Math.floor(normalizedMinutes / FitosanitariosFormComponent.MINUTES_PER_HOUR);
    const minutes = normalizedMinutes % FitosanitariosFormComponent.MINUTES_PER_HOUR;

    return [hours, minutes]
      .map((timePart) => timePart.toString().padStart(FitosanitariosFormComponent.TIME_PART_PAD_LENGTH, '0'))
      .join(':');
  }

  private updateHorasRequired(): void {
    const v = this.form.model.aplicado;
    const aplicado = v === '1' || v === true || (v as unknown) === 1;

    for (const section of this.form.formFields.sections ?? []) {
      for (const field of section.fields ?? []) {
        if (field.name === 'hora_inicio' || field.name === 'hora_fin') {
          field.conditions.isRequired = aplicado;
        }
      }
    }

    const fg = this.formBuilderRef.model;
    if (fg) {
      for (const name of ['hora_inicio', 'hora_fin']) {
        const control = fg.get(name);
        if (!control) continue;

        if (aplicado) {
          control.addValidators(Validators.required);
        } else {
          control.removeValidators(Validators.required);
        }
        control.updateValueAndValidity({ emitEvent: false });
      }
    }

    this.formBuilderRef.updateForm(this.form.model, false);
  }

  private resolveCurrentTratamiento(): TratamientosModel | null {
    return this.resolveSelectedDropdownEntity<TratamientosModel>(
      this.form.lists.tratamientos,
      this.form.model.id_tratamiento ?? this.form.model.tratamiento_nombre ?? this.form.model.tratamiento ?? null,
    );
  }

  private resolveSelectedDropdownEntity<TEntity>(
    dropdown: DropdownData<TEntity>,
    value: unknown,
  ): TEntity | null {
    return this.resolveSelectedDropdownEntities(dropdown, value)[0] ?? null;
  }

  private resolveSelectedDropdownEntities<TEntity>(
    dropdown: DropdownData<TEntity>,
    value: unknown,
  ): TEntity[] {
    const selectedIds = this.getReactiveValueIds(value);

    if (selectedIds.length === 0) {
      return [];
    }

    const options = [
      ...(dropdown.filtered ?? []),
      ...(dropdown.values ?? []),
    ];
    const resolved: TEntity[] = [];
    const seenIds = new Set<string>();

    for (const selectedId of selectedIds) {
      const option = options.find(candidate => this.dropdownOptionMatchesValue(candidate, selectedId));
      const entity = option ? this.getDropdownOptionEntity<TEntity>(option) : null;
      const entityId = this.getReactiveValueId(entity);

      if (entity && !seenIds.has(entityId)) {
        resolved.push(entity);
        seenIds.add(entityId);
      }
    }

    return resolved;
  }

  private getReactiveValueIds(value: unknown): string[] {
    if (value === null || value === undefined) {
      return [];
    }

    if (Array.isArray(value)) {
      return value
        .flatMap(item => this.getReactiveValueIds(item))
        .filter(item => item.length > 0);
    }

    if (typeof value === 'string') {
      return value
        .split(';')
        .map(item => item.trim())
        .filter(item => item.length > 0);
    }

    const id = this.getReactiveValueId(value);

    return id.length > 0 ? [id] : [];
  }

  private dropdownOptionMatchesValue<TEntity>(
    option: { value: TEntity | null; label?: string; raw?: unknown; valueAliases?: readonly unknown[] },
    selectedId: string,
  ): boolean {
    const candidateIds = [
      this.getReactiveValueId(option.value),
      this.getReactiveValueId(option.raw),
      String(option.label ?? ''),
      ...(option.valueAliases ?? []).map(alias => this.getReactiveValueId(alias)),
    ];

    return candidateIds.some(candidateId => candidateId === selectedId);
  }

  private getDropdownOptionEntity<TEntity>(option: { value: TEntity | null; raw?: unknown }): TEntity | null {
    const rawEntity = option.raw ?? option.value;

    return rawEntity && typeof rawEntity === 'object'
      ? rawEntity as TEntity
      : null;
  }

  private getReactiveValueId(value: unknown): string {
    if (typeof value === 'object' && value !== null && 'id' in value) {
      return String((value as { id?: unknown }).id ?? '');
    }

    return String(value ?? '');
  }

  private shouldSkipClientDropdownReload(changedFieldName: string): boolean {
    if (changedFieldName !== 'id_cliente') {
      return false;
    }

    const selectedClientId = this.getReactiveValueId(this.form.model.id_cliente as unknown);
    const hasExplicitClientFilter = Boolean(this.form.cliente?.id);
    const shouldSkip = !selectedClientId
      || !hasExplicitClientFilter
      || this.loadingData
      || this.isLoadingInitialDropdowns
      || this.isReloadingClientDropdowns
      || selectedClientId === this.lastReloadedClientDropdownId;

    if (shouldSkip) {
      this.debugFito('Client dropdown reload skipped.', {
        changedFieldName,
        selectedClientId,
        hasExplicitClientFilter,
        loadingData: this.loadingData,
        isLoadingInitialDropdowns: this.isLoadingInitialDropdowns,
        isReloadingClientDropdowns: this.isReloadingClientDropdowns,
        lastReloadedClientDropdownId: this.lastReloadedClientDropdownId,
      });
    }

    return shouldSkip;
  }

  private traceFormChange(changedFieldName: string, formModel: ReactiveFormValue<TareaFitoModel>): void {
    if (!this.debugFitosanitariosForm) {
      return;
    }

    this.formChangesDebugCount += 1;
    this.repeatedChangeDebugCount = this.lastDebugChangedFieldName === changedFieldName
      ? this.repeatedChangeDebugCount + 1
      : 1;
    this.lastDebugChangedFieldName = changedFieldName;

    if (
      this.formChangesDebugCount % FitosanitariosFormComponent.DEBUG_LOG_INTERVAL !== 0 &&
      this.repeatedChangeDebugCount < FitosanitariosFormComponent.DEBUG_REPEATED_CHANGE_THRESHOLD
    ) {
      return;
    }

    this.debugFito('formChanges trace.', {
      changedFieldName,
      formChangesDebugCount: this.formChangesDebugCount,
      repeatedChangeDebugCount: this.repeatedChangeDebugCount,
      idCliente: this.getReactiveValueId(this.form.model.id_cliente as unknown),
      loadingData: this.loadingData,
      isLoadingInitialDropdowns: this.isLoadingInitialDropdowns,
      isReloadingClientDropdowns: this.isReloadingClientDropdowns,
      changedValue: formModel[changedFieldName],
    });
  }

  private debugFito(message: string, data?: unknown): void {
    if (!this.debugFitosanitariosForm) {
      return;
    }

    console.warn('[FitosanitariosForm]', message, data ?? '');
  }
}
